import css from '@emotion/css';
import fontFaceCSS from './fontface';

const globalStyles = css`
  ${fontFaceCSS}
`;

export default globalStyles;
